export default "__VITE_ASSET__ntESjt1o__";